import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { Document, Image, Line, Page, PDFViewer, Svg, Text, View } from '@react-pdf/renderer';
import { DadosEstabelecimento } from 'pages/comprovante-nota-fiscal-outros/comprovante-nota-fiscal-outros.model';
import ComprovanteNFOutrosService from 'pages/comprovante-nota-fiscal-outros/comprovante-nota-fiscal-outros.service';
import { mascaraCpfCnpj } from 'pages/cpfNota/CpfNota';
import { useEffect, useState } from 'react';
import { theme } from 'theme';
import { DateFormat, DatePattern } from 'utils/date-format';
import { RegistroCupomTrocaImpressao } from './cupom-troca.model';

export type CupomTrocaImpressaoProps = {
    registros: Array<RegistroCupomTrocaImpressao>;
    estabelecimentoNome: string;
    notaInfo: {
        tipo: 'NFC-e' | 'NF-e';
        numero: string;
        serie: string;
        emissao?: string;
    };
    onClose: () => void;
};

const initialStateDadosPessoa: DadosEstabelecimento = {
    cnpj: '',
    inscricaoEstadual: '',
    enderecoCompleto: '',
    cidadeEstado: '',
    codigo: '',
    nome: ''

};

const CupomTrocaImpressao = (props: CupomTrocaImpressaoProps) => {
    const [dadosEstabelecimento, setDadosEstabelecimento] = useState<DadosEstabelecimento>(initialStateDadosPessoa);
    const comprovanteService = ComprovanteNFOutrosService();

    useEffect(() => {
        comprovanteService
            .getDadosPessoa()
            .then(({ data }) => {
                if (data.cnpj) {
                    setDadosEstabelecimento(data);
                }
            })
            .catch(() => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <IconButton
                sx={{
                    zIndex: 100000,
                    position: 'absolute',
                    bottom: 20,
                    right: 30,
                    backgroundColor: theme.palette.primary.main,
                    ':hover': {
                        backgroundColor: theme.palette.primary.main,
                        filter: 'grayscale(.2) brightness(.8) contrast(1.5)',
                    },
                }}
                onClick={props.onClose}
            >
                <CloseIcon sx={{ color: theme.palette.background.default, fontSize: 45 }} />
            </IconButton>
            <PDFViewer
                style={{
                    zIndex: 10000,
                    width: '100%',
                    height: '100vh',
                    border: 0,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
                showToolbar={true}
            >
                <Document title='Cupom de troca' author={''} language='pt-BR'>
                    <Page
                        size={{ width: 320 }}
                        orientation='portrait'
                        wrap={false}
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            paddingTop: '20px',
                        }}
                    >

                        <View
                            style={{
                                width: '90%',
                                paddingBottom: '15px',
                                marginBottom: '15px',
                                alignItems: 'flex-start',
                            }}
                        >
                            <Text style={{ fontSize: '10px' }}>=================================================</Text>
                            <Text style={{ fontSize: '16px', fontFamily: 'Helvetica-Bold', margin: '5px 0', textAlign: 'center', width: '100%' }}>CUPOM DE TROCA</Text>
                            <Text style={{ fontSize: '10px' }}>=================================================</Text>

                            <Text style={{ fontSize: '14px', marginTop: '10px' }}>Estabelecimento:</Text>
                            <Text style={{ fontSize: '14px' }}>{dadosEstabelecimento.nome}</Text>
                            <Text style={{ fontSize: '14px' }}>CNPJ: {mascaraCpfCnpj(dadosEstabelecimento.cnpj)}</Text>
                            <Text style={{ fontSize: '14px' }}>{dadosEstabelecimento.enderecoCompleto}</Text>
                            <Text style={{ fontSize: '14px' }}>{dadosEstabelecimento.cidadeEstado}</Text>

                            <Svg height={2} style={{ marginTop: '10px' }}>
                                <Line
                                    x1="0"
                                    y1="0"
                                    x2="300"
                                    y2="0"
                                    strokeWidth={2}
                                    stroke="#000"
                                />
                            </Svg>

                            <Text style={{ fontSize: '14px', marginTop: '10px' }}>
                                {props.notaInfo.tipo}: {props.notaInfo.numero}
                            </Text>
                            <Text style={{ fontSize: '14px' }}>Série: {props.notaInfo.serie}</Text>

                            <Svg height={2} style={{ marginTop: '13px' }}>
                                <Line
                                    x1="0"
                                    y1="0"
                                    x2="300"
                                    y2="0"
                                    strokeWidth={2}
                                    stroke="#000"
                                />
                            </Svg>

                            {props.registros.map((registro, index) => (
                                <View key={index} style={{ width: '100%', marginTop: '18px' }}>
                                    <Text style={{ fontSize: '14px' }}>{registro.descricaoSku}</Text>

                                    {!!registro.barcodeUrl && (
                                        <Image
                                            src={registro.barcodeUrl}
                                            style={{ width: '100%', height: '40px', objectFit: 'cover', marginTop: '3px' }}
                                        />
                                    )}


                                    <Text style={{ fontSize: '12px', marginTop: '2px', width: '100%', textAlign: 'center' }}>{registro.codigo}</Text>
                                </View>
                            ))}

                               <Svg height={2} style={{ marginTop: '15px' }}>
                                <Line
                                    x1="0"
                                    y1="0"
                                    x2="300"
                                    y2="0"
                                    strokeWidth={2}
                                    stroke="#000"
                                />
                            </Svg>

                            <Text style={{ fontSize: '14px', marginTop: '10px' }}>
                                Apresente este cupom no atendimento para localizar a venda e iniciar o processo de troca.
                            </Text>

                            {!!props.notaInfo.emissao && (
                                <Text style={{ fontSize: '14px', marginTop: '10px' }}>Emissão: {DateFormat.formatDateTime(props.notaInfo.emissao, DatePattern.DATE_TIME)}</Text>
                            )}

                            <Text style={{ fontSize: '14px', marginTop: '10px' }}>
                                Este cupom está vinculado exclusivamente à {props.notaInfo.tipo} identificada acima.
                            </Text>
                            <Text style={{ fontSize: '14px', marginTop: '10px' }}>
                                Este documento não possui valor fiscal.
                            </Text>
                            <Text style={{ fontSize: '10px', marginTop: '5px' }}>=================================================</Text>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default CupomTrocaImpressao;
